import { AnnouncementModal } from './announcement-modal';
import { useActiveAnnouncement } from './announcements';

/**
 * Mounts the first eligible, not-yet-dismissed announcement from the registry.
 * Drop this once in DashboardLayout — it renders on any authed page and shows
 * at most one announcement at a time.
 */
export function ActiveAnnouncement() {
  const announcement = useActiveAnnouncement();
  if (!announcement) return null;
  return <AnnouncementModal {...announcement} />;
}
